import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

interface Props {
  slug: string;
  titleTh: string;
  chapter: number;
  percent: number;
}

export function ContinueReadingBar({ slug, titleTh, chapter, percent }: Props) {
  if (percent >= 100) return null;
  const size = 28;
  const stroke = 2.5;
  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const offset = c - (Math.max(0, Math.min(100, percent)) / 100) * c;


  return (
    <Link
      to={`/ebook/${slug}/read/${chapter}`}
      className="flex items-center gap-3 mb-6 transition-all hover:bg-[rgba(242,116,5,0.07)]"
      style={{
        background: 'rgba(242,116,5,0.04)',
        borderLeft: '2px solid #F27405',
        borderRadius: 10,
        padding: '12px 14px',
      }}
    >
      <svg width={size} height={size} className="shrink-0 -rotate-90">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(101,147,166,0.2)" strokeWidth={stroke} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke="#F27405"
          strokeWidth={stroke}
          strokeDasharray={c}
          strokeDashoffset={offset}
          strokeLinecap="round"
        />
      </svg>
      <div className="flex-1 min-w-0">
        <div className="text-[12px] truncate" style={{ color: '#F0F8FF' }}>
          อ่านต่อ {titleTh}
          <span style={{ color: '#3D6D82' }}> — บทที่ {chapter}</span>
        </div>
      </div>
      <ArrowRight size={16} color="#F27405" />
    </Link>
  );
}
